<template>
    <div>
        <div id="sitePreConfig-container">
            <table class="siteConfigTable">
                <tr>
                    <td class="title" style="width:40%;">当前场地</td>
                    <td class="title" style="width:60%;">指定场地</td>
                </tr>
                <tr v-for="n in siteInfoArray.length">
                    <td class="content">{{ siteInfoArray[n-1].oriSiteName.replace(/\+/g, '、') }}</td>
                    <td class="content">
                        <el-select v-model="siteInfoArray[n-1].newSiteCode" placeholder="如未选择将保留原场地信息" style="width:99%;" @change="handleSiteChange" multiple filterable clearable>
                            <el-option v-for="(item, index) in comboOption.site[n-1]"
                                :key="item.comboValue"
                                :value="item.comboValue"
                                :label="item.comboName + '（' + item.capacity + '人）'">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
        </div>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    deptCode: null,
                    siteCode: null,
                },
                comboOption: {
                    site: []
                },
                oriSiteCode: null,
                oriSiteName: null,
                siteInfoArray: [],
                containerHeight: null,
            }
        },
        mounted() {
        },
        methods: {
            async parseSiteInfo(){
                let oriSiteCodeArray = this.oriSiteCode.split('&');
                let oriSiteNameArray = this.oriSiteName.split('&');

                for(let i=0; i<oriSiteCodeArray.length; i++){
                    this.queryForm.siteCode = oriSiteCodeArray[i];
                    await this.queSiteCombo(i);

                    let siteInfo = {
                        oriSiteCode: oriSiteCodeArray[i],
                        oriSiteName: oriSiteNameArray[i],
                        newSiteCode: [],
                    };

                    this.siteInfoArray.push(siteInfo);
                }

                this.$nextTick().then(() => {
                    this.containerHeight = document.getElementById('sitePreConfig-container').offsetHeight;
                    this.$emit('updateSitePreConfigDialogHeight', this.containerHeight + 65);
                });
            },
            async queSiteCombo(index){
                await this.$api.timetableManage.arrange.queSiteComboByType({
                    data: this.queryForm
                }).then((response) => {
                    this.comboOption.site[index] = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
            handleSiteChange(){
                setTimeout(() => {
                    if(this.containerHeight != document.getElementById('sitePreConfig-container').offsetHeight){
                        this.containerHeight = document.getElementById('sitePreConfig-container').offsetHeight;
                        this.$emit('updateSitePreConfigDialogHeight', this.containerHeight + 65);
                    }
                }, 100);
            },
            confirm() {
                let finalSiteCode = '';
                let finalSiteName = '';

                for(let i=0; i<this.siteInfoArray.length; i++){
                    const siteInfo = this.siteInfoArray[i];

                    if(siteInfo.newSiteCode.length > 0){
                        for(let j=0; j<siteInfo.newSiteCode.length; j++){
                            let tempSiteCode = siteInfo.newSiteCode[j];
                            finalSiteCode += tempSiteCode + '+';

                            for(let k=0; k<this.comboOption.site[i].length; k++){
                                if(tempSiteCode == this.comboOption.site[i][k].comboValue){
                                    finalSiteName += this.comboOption.site[i][k].comboName + '+';
                                }
                            }
                        }

                        finalSiteCode = finalSiteCode.substring(0, finalSiteCode.length-1);
                        finalSiteName = finalSiteName.substring(0, finalSiteName.length-1);
                    }else{
                        finalSiteCode += this.siteInfoArray[i].oriSiteCode;
                        finalSiteName += this.siteInfoArray[i].oriSiteName;
                    }

                    finalSiteCode += '&';
                    finalSiteName += '&';
                }

                finalSiteCode = finalSiteCode.substring(0, finalSiteCode.length-1);
                finalSiteName = finalSiteName.substring(0, finalSiteName.length-1);

                this.$emit('updateSitePreConfigInfo', finalSiteCode, finalSiteName);
            },
            //关闭对话框
            closeDialog() {
                this.$emit('closeSitePreConfigDialog');
            },
        },
    }
</script>

<style scoped>
    .siteConfigTable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
    }

    .siteConfigTable .title {
        height: 50px;
        background-color: #F1FAF6;
        border: 1px solid #DCDFE6;
        font-weight: bold;
        text-align: center;
    }

    .siteConfigTable .content {
        height: 50px;
        border: 1px solid #DCDFE6;
        padding-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// sitePreConfig.vue?68c5aa52